import React from 'react'
import styles from './styles.module.scss'
import Avatar from 'srcReact/components/common2/Avatar'
import LightProfileProto from 'srcReact/components/common2/LightProfileModal/LightProfilPrototype'
import { lightProfileActions } from 'srcReact/components/common2/LightProfileModal/actions'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'

function User({ user, lastUserRef, loggedInUserId, selectUser }) {
  const dispatch = useDispatch()
  const { t } = useTranslation()

  return (
    <button className={`${styles.user} ${user.role === 'invited' && styles.userInvited}`} onClick={selectUser}>
      <Avatar
        userId={user.id}
        firstname={user.firstname}
        lastname={user.lastname}
        commonInterestsCount={user.interests_in_common && user.interests_in_common.length}
        profilePicture={user.profile_picture}
        lastMemberRef={lastUserRef}
        key={'member_' + user.id}
        containerCSS={styles.avatarContainer}
        userNameCSS={styles.userNameCSS}
        rounded
        showUserName
        showCommonInterests={user.id !== loggedInUserId}
        mimeType={user.mime_type}
        originalTag={user.original_tag}
        isOriginal={user.is_original}
        imgWrapperSize='large84'
        focusable={false}
        showRole={user.role === 'invited'}
        withExpertiseGroup={user.with_expertise_group}
        role={user.role === 'invited' ? t('components.avatar.invited') : ''}
      />
    </button>
  )
}

export default User
